import { GUIDE_SURFACES, type GuideSurfaceId } from './featureLinks';

export type PageGuide = {
  surfaceId: GuideSurfaceId;
  /** The topic whose hub the page sentence opens. */
  topic: string;
};

/**
 * The topic hub behind each route's page sentence (GDN-3704, AC-14). One
 * entry per page: a page shows at most one sentence (AC-6), so a route
 * appears here once and `PageGuideLink` warns in development when two mount
 * together. A page whose hub is not published yet (scheduling, until
 * GDN-3682) renders nothing until it lands. The chart topic's sentence sits
 * on the patients index, not the chart header: the row beside a patient's
 * name is working space (Alfred, September 11, 2026).
 */
export const PAGE_GUIDES = {
  schedule: { surfaceId: GUIDE_SURFACES.PAGE_SCHEDULE, topic: 'scheduling' },
  patients: { surfaceId: GUIDE_SURFACES.PAGE_PATIENTS, topic: 'chart' },
  eligibilityChecks: { surfaceId: GUIDE_SURFACES.PAGE_ELIGIBILITY_CHECKS, topic: 'eligibility' },
  practiceSettings: { surfaceId: GUIDE_SURFACES.PAGE_PRACTICE_SETTINGS, topic: 'access' },
} as const satisfies Record<string, PageGuide>;

export type PageGuideKey = keyof typeof PAGE_GUIDES;
